import { AsyncPipe, CurrencyPipe, DatePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@jsverse/transloco';
import { InvoiceService } from '../domain/data-access/invoice.service';

@Component({
  selector: 'rma-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    CurrencyPipe,
    DatePipe,
    NgClass,
    MatTableModule,
    MatButtonModule,
    MatTooltipModule,
    MatDividerModule,
    TranslocoModule,
  ],
})
export class InvoicesComponent {
  private readonly invoiceService = inject(InvoiceService);
  protected readonly invoices$ = this.invoiceService.invoices$;
}
